<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-28 19:04:17
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\CustomForm\CustomFormRecord\viewCustomFormRecord.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-11 12:01:43
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_CustomFormRecord_list_viewTitle')"
    backgroundClass="transparent"
    widthClass="max-1000"
    pad="0"
  >
    <!-- content -->
    <template v-slot:page-main>
      <noContent v-if="!Data" />
      <ApprovalTriger
        v-if="Data"
        :bg-color="Data.approval_bg_color"
        :slide-color="Data.approval_tint_color"
        @triger="
          $toPage(
            '/admin/custom-form-record/detail/' +
              $route.params.params +
              '/approval-detail/' +
              $route.params.params
          )
        "
      >
        <template v-slot:time>
          {{ $getDateTime(Data.operate_utc_datetime, "YYYY/MM/DD HH:mm") }}
        </template>
        <template v-slot:status>
          {{ $getCommonLangValue(Data.status_detail) }}
        </template>
      </ApprovalTriger>
      <Section v-if="Data">
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_swiftNumberLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              v-model="Data.swift_number"
              :label="$t('label_essweb_leaveApplication_form_swiftNumberLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_submitDateLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="
                $getDateTime(Data.submission_utc_datetime, 'YYYY/MM/DD HH:mm')
              "
              :label="$t('label_essweb_leaveApplication_form_submitDateLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_applicantLabel")
            }}</v-sheet>
            <v-autocomplete
              single-line
              v-model="user"
              readonly
              :items="users"
              append-icon
              item-value="uuid"
            >
              <template v-slot:no-data>
                <noContent />
              </template>
              <template v-slot:selection="data">
                <v-chip pill v-bind="data.attrs" :input-value="data.selected">
                  <StaffAvatar
                    left
                    :src="data.item.staff_avatar"
                    :staff_name="data.item.preferred_name"
                  />
                  {{ $getCommonLangValue(data.item.preferred_name) }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </Section>
      <Section
        v-if="Data && Data['ess_common_application_type_custom_field_value']"
      >
        <v-form
          ref="form"
          lazy-validation
          v-if="
            Data['ess_common_application_type_custom_field_value'].length > 1
          "
        >
          <v-row>
            <DynamicForm
              :data="item"
              v-for="(item, index) in Data[
                'ess_common_application_type_custom_field_value'
              ]"
              :key="`formitem--${index}`"
              :iSEdited="iSEdited"
              @change="
                (uuid, value, change) => {
                  item['_value'] = value;
                  item['is_changed'] = !change;
                }
              "
            />
          </v-row>
        </v-form>
        <v-row v-else>
          <DynamicForm
            :data="item"
            :iSEdited="iSEdited"
            v-for="(item, index) in Data[
              'ess_common_application_type_custom_field_value'
            ]"
            :key="`formitem--${index}`"
            @change="
              (uuid, value, change) => {
                item['_value'] = value;
                item['is_changed'] = !change;
              }
            "
          />
        </v-row>
      </Section>
    </template>
    <template v-slot:tools-main> </template>
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        submitBtn
        @submit="toSave"
        @cancel="toBack"
      />
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "viewCustomRecordApplication",
  components: {},
  computed: {},
  data() {
    return {
      page_params: {
        flow_status: 0,
      },
      isOnlineChange: false,
      Data: null,
      iSEdited: false,
      users: [],
      table_name: "",
      Tables: [
        "ess_workflow_cancellation_application_record",
        "ess_lv_leave_application_record",
        "ess_clm_claim_form_records",
        "ess_att_roster_form_records",
        "ess_punch_invalid_record_application",
        "ess_att_attendance_modification_application",
      ],
      user: null,
    };
  },
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.params)); //解密参数
    this.getDetail();
  },
  watch: {},
  filters: {},
  methods: {
    toBack: function () {
      if (this.iSEdited) {
        this.iSEdited = false;
        this.getDetail();
      } else {
        this.$router.back();
      }
    },
    onInputImage: function (image) {
      this.Data.attachments = image;
    },
    toSave() {
      const that = this;
      let arr = [];
      if (this.Data["attachments"])
        this.Data["attachments"].map((ite) => {
          arr.push(ite.uuid);
        });
      that
        .$Request({
          method: "POST",
          table: "ess_lv_leave_application_record",
          url: "/leave/update-leave-table/",
          data: {
            uuid: this.page_params.id,
            attachment_uuid: arr.join(","),
          },
        })
        .then((res) => {
          that.$showMessage({
            type: "success",
            text: that.$t(
              "message_essweb_myLeaveApplication_form_afterUpdateFileSuccessLabel"
            ),
          });
          if (that.Data["attachments"]) {
            that.isOnlineChange = Math.random() * 9999999;
          }
          that.getDetail();
        });
    },
    getDetail: function () {
      const that = this;
      that.iSEdited = false;
      // that.Data = null;
      this.$Request({
        method: "POST",
        table: "ess_common_application_record",
        url: "/application/get-application-details/",
        data: {
          uuid: this.page_params.id,
        },
      }).then((res) => {
        that.user = res.data.uuid;
        that.users = [
          {
            staff_avatar: res.data.agent_staff.staff_avatar,
            uuid: res.data.uuid,
            preferred_name: res.data.agent_staff.preferred_name,
          },
        ];
        if (res.data["ess_common_application_type_custom_field_value"])
          res.data["ess_common_application_type_custom_field_value"].map(
            (item) => {
              item["is_changed"] = false;
              item["_value_init"] = that.$defaultInitValue(
                item.custom_field_data_type
                  ? item.custom_field_data_type
                  : "string",
                item.custom_field_value
              );
              item["_value"] = that.$defaultInitValue(
                item.custom_field_data_type
                  ? item.custom_field_data_type
                  : "string",
                item.custom_field_value
              );
              item["_uuid"] = item.uuid;
            }
          );
        that.Data = res.data;
      });
    },
  },
};
</script>
